module.exports = __webpack_public_path__ + "img/7065c6c.jpg";